<h1 mat-dialog-title>{{'account.selectProfile' | translate}}</h1>

<mat-dialog-content>
  <div class="account-grid">
    <mat-card
      *ngFor="let account of data.multicomptes"
      class="account-card"
      (click)="onSelectAccount(account)"
    >
      <mat-card-header>
        <mat-card-title>{{ account.profile_name }}</mat-card-title>
      </mat-card-header>
    </mat-card>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>{{'common.cancel' | translate}}</button>
</mat-dialog-actions>
